import { request } from "../base";

export type AdminUser = {
	id: string;
	name: string;
	email: string;
	emailVerified: boolean;
	phoneNumber: string | null;
	banned: boolean;
	banReason: string | null;
	createdAt: string;
	updatedAt: string;
};

export type UserTenantRole = {
	id: number;
	userId: string;
	tenantType: "platform" | "pro";
	tenantId: string | null;
	role: string;
	dateCreated: string;
};

export const adminUsersApi = {
	async listUsers(params?: Record<string, string>) {
		const query = params ? `?${new URLSearchParams(params).toString()}` : "";
		return request<AdminUser[]>(`/api/admin/users${query}`);
	},

	async createUser(data: {
		name: string;
		email: string;
		password: string;
		phoneNumber?: string;
	}) {
		return request<AdminUser>(`/api/admin/users`, {
			method: "POST",
			body: data,
		});
	},

	async getUser(id: string) {
		return request<{ user: AdminUser; roles: UserTenantRole[] }>(
			`/api/admin/users/${id}`,
		);
	},

	async updateUser(id: string, data: Partial<AdminUser>) {
		return request<AdminUser>(`/api/admin/users/${id}`, {
			method: "PUT",
			body: data,
		});
	},

	async resetUserPassword(id: string, password: string) {
		return request<{ message: string }>(
			`/api/admin/users/${id}/reset-password`,
			{
				method: "POST",
				body: { password },
			},
		);
	},

	async deleteUser(id: string) {
		return request(`/api/admin/users/${id}`, {
			method: "DELETE",
		});
	},

	async banUser(id: string, banned: boolean, banReason?: string) {
		return request<AdminUser>(`/api/admin/users/${id}/ban`, {
			method: "POST",
			body: { banned, banReason },
		});
	},

	async addUserRole(
		userId: string,
		data: {
			tenantType: "platform" | "pro";
			tenantId?: string;
			role: string;
		},
	) {
		return request<UserTenantRole>(`/api/admin/users/${userId}/roles`, {
			method: "POST",
			body: data,
		});
	},

	async removeUserRole(userId: string, roleId: number) {
		return request(`/api/admin/users/${userId}/roles/${roleId}`, {
			method: "DELETE",
		});
	},
};
